import React from 'react';

import * as PropTypes from 'prop-types';
import { classes } from 'as-ui-kit/utils/styles';
import styles from './styles.modules.scss';

const PaySourceSelector = ({children, isActive, onClick}) => (
    <button
        className={classes(
            styles['source-selector'],
            isActive && styles['active']
        )}
        type="button"
        onClick={onClick}
    >
        {children}
    </button>
);

export default PaySourceSelector;

PaySourceSelector.propTypes = {
    children: PropTypes.node,
    isActive: PropTypes.bool,
    onClick: PropTypes.func
};
